import React from 'react'

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";

import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";

export default function LinguisticEvaluation(props) {
  const { data, dir, ins = [], course, comments = [] } = props
  const tl = dir === 'rtl' ? 'text-18' : 'text-14';

  const displayOptionLabel = (lureObj, statementObj) => {
    switch (lureObj.correct_option) {
      case 1:
        return statementObj.option_1
      case 2:
        return statementObj.option_2
      case 3:
        return statementObj.option_3
    }
  }

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => { 
    return comments.filter((comment) => comment.component === component && comment.internality !== true).length; 
};

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Instructions:
      </Typography>

      <Instructions ins={ins} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      {data.statements.map((statement, index) => (
        <div key={`question-${index}`}>
          <Typography className="text-14 font-bold p-16 pb-0">
            Statement {index + 1}:
          </Typography>
          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            {statement.materials.map((material, num) => (
              <Grid key={num} container spacing={0}>
                <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    Authentic {material.media_material ? 'Listening' : 'Reading'} Material:
                  </Typography>
                  <Divider className="my-16" />
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid item xs={12} sm={4} lg={2}>
                      <Typography className="text-14 font-semibold m-0">
                        Title (TL):
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={10}>
                      <Typography className={`${tl} m-0`} dir={dir}>
                        {material.material_title_tl}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={2}>
                      <Typography className="text-14 font-semibold my-16">
                        Title (EN):
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={10}>
                      <Typography className="text-14 my-16">
                        {material.material_title_en}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={2}>
                      <Typography className="text-14 font-semibold m-0">
                        Link:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={10}>
                      <Typography className="text-14 m-0">
                        {material.link}
                      </Typography>
                    </Grid>
                    {material.sp_url && (
                      <>
                        <Grid item xs={12} sm={4} lg={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Sharepoint Source:
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} lg={10}>
                          <Button
                            variant="contained"
                            endIcon={<BASESvgIcon size={20}>heroicons-outline:external-link</BASESvgIcon>}
                            color="secondary"
                            size="small"
                            href={material.sp_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ bgcolor: '#013bb1 !important', color: '#ffffff !important', '&:hover': { bgcolor: '#001680 !important' } }}
                          >
                            View Material
                          </Button>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Paper>
            
          <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Statement {index + 1}:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={`${tl} m-0`} dir={dir}>
                      {statement.prompt}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                  <Typography className="text-14 font-bold m-0">
                    Statement Options:
                  </Typography>
                  <Divider className="my-16" />
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={2} sm={1}>
                        <Typography className="text-14 font-semibold m-0">
                          Option 1:
                        </Typography>
                        <Typography className="text-14 font-semibold m-0">
                          Option 2:
                        </Typography>
                        <Typography className="text-14 font-semibold m-0">
                          Option 3:
                        </Typography>
                      </Grid>
                      <Grid item xs={10} sm={11}>
                        <Typography className={`${tl} m-0`}>
                          {statement.option_1}
                        </Typography>
                        <Typography className={`${tl} m-0`}>
                          {statement.option_2}
                        </Typography>
                        <Typography className={`${tl} m-0`}>
                          {statement.option_3}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Lures:
                </Typography>
                <Divider className="my-16" />
                <Grid container spacing={0}>
                  {statement.lures.map((lure, index) => (
                    <Grid key={`lure-${lure.lure_text}-${index}`} item xs={12}>
                      {index > 0 && <Divider className="my-0" />}
                      <Grid container spacing={1} className="mb-16">
                        <Grid item xs={4} sm={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Lure:
                          </Typography>                          
                        </Grid>
                        <Grid item xs={8} sm={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {lure.lure_text}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className="mb-16">
                        <Grid item xs={4} sm={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Correct Option:
                          </Typography>                          
                        </Grid>
                        <Grid item xs={8} sm={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {displayOptionLabel(lure, statement)}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} className={index < statement.lures.length - 1 ? `mb-16` : `mb-0`}>
                        <Grid item xs={4} sm={2}>
                          <Typography className="text-14 font-semibold m-0">
                            Correct Feedback:
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={10}>
                          <Typography className={`${tl} m-0`} dir={dir}>
                            {lure.lure_correct_feedback}
                          </Typography>
                        </Grid>
                      </Grid>                   
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      First Incorrect Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography 
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: statement.incorrect_feedback_1 }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography className="text-14 font-bold m-0">
                      Second Incorrect Feedback:
                    </Typography>
                    <Divider className="my-16" />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography 
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: statement.incorrect_feedback_2 }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </div>
      ))}
      {
        data.eMentor.length !== 0 && <EMentor eMentor={data.eMentor} tl={tl} dir={dir} componentCommentsCount={componentCommentsCount} />
      }
    </div>
  );}
